import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss']
})
export class SvgIconComponent {

  @HostBinding('style.--svg-url') private _pathIdentifier!: string;

  @Input()
  public set pathIdentifier(identifier: string) {
    this._pathIdentifier = `url("${this.getFilePath(identifier)}")`;
  }


  private getFilePath(identifier: string): string {
    let fileName = "";

    switch (identifier) {
      case 'all':
        fileName = 'allgames'
        break;
      case 'video-poker':
        fileName = 'videopoker'
        break;
      case 'provider': //for more games for the same provider in selected games
        fileName = 'providers'
        break;
      case 'recent':
        fileName = 'recently'
        break;
      case 'recommended-for-user':
        fileName = 'trynext'
        break;
      case 'recommended-most-played':
        fileName = 'most_played'
        break;
      default:
        fileName = identifier
    }

    return `assets/icons/${fileName}.svg`
  }


}
